<template>
    <div class="p-20">
        <div class="container-main">
            <div class="flex justify-center ph-20">
                <div class="breadcrumbs mt-20 w-full " >
                    <router-link to="/admin/logs/" class="main-item">
                        Logs
                    </router-link>
                    <img src="@/assets/arrow-opener.svg" alt="arrow-right"  class="p-10" />
                    <div class="last-item" >
                        <div>{{props.date}}</div> 
                    </div>
                </div>
            </div>
            <div class="logs-conteiner flex column gap-20"> 
                <div class="filters bg-white p-20 flex column gap-20">
                    <div class="text-left flex gap-20 items center">
                        <div class="flex items-center">Filters</div>
                        <button class="w-content" @click="filters.push({value: '', id: generateId()})">New Filter</button>


                    </div>

                    <div v-for="(filter, index) in filters" class="flex row gap-20 items-center">
                        <InpComponent
                            :no-margin="true"
                            type="text"
                            placeholder="Filter"
                            :key="`filter-item-${filter.id}`"
                            :value="filter.value"
                            :key_ref="index"
                            @inputChange="inputChangeFunc"
                        >
                        </InpComponent>
                        <button class="w-content" @click="filters.splice(index, 1)">Delete</button>
                    </div>
                </div>
                <div class="w-full overflow-x-auto overflow-y-auto logs border-box">
                    <div v-for="(item, index) in rowsToShow " :key="`log-${index}`" class="log-item no-wrap">
                        <div class="text-left w-full log-info" @dblclick="copyItem(item)">{{ formattedText(item) }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

    import { ref, onMounted, computed, onBeforeUnmount } from 'vue';
    import BO_API from '../api/bo_api.js'
    import InpComponent from '@/components/InpComponent.vue';

    const props = defineProps(['date'])
    const content = ref([]);
    const filters = ref([]);

    function generateId(){
        return Math.random().toString(36).substring(7);
    }


    const rowsToShow = computed(()=> {
        const result = content.value.filter(el => {
            for(let filter of filters.value){
                if (!el.includes(filter.value)){
                    return false
                }
                if (el.includes('/bo/v1/get-log/')){
                    return false
                }
            }
            return true
        })
        return result
    }) 

    async function loadData(){
        const resp = await BO_API.getLog(props.date);
        content.value = resp.rows;
    }
    onMounted(async () => {

        await loadData();
        filters.value.push({ value: '', id: generateId() });
        initPol()
    })

    function copyItem(item){
        navigator.clipboard.writeText(item);
    }
    const formattedText = (text) => {
        return text.replace(/\\n/g, '\n')
    }
    function inputChangeFunc(event) {
        console.log(event)
        const event_type = event[0];
        const event_value = event[1];
        filters.value[event_type].value = event_value;
    }
    let intervalId = null;

    function initPol(){
        const today = new Date().toISOString().split('T')[0];
        if (props.date === today) {
            intervalId = setInterval(() => {
                loadData();
            }, 8000);
        }
    }

    onBeforeUnmount(() => {
        if (intervalId) {
            clearInterval(intervalId);
        }
    });

</script>

<style scoped lang="scss">
    .logs-conteiner {
        padding-left: 40px;
        padding-top: 40px;
    }
    .log-item {
        border-bottom: 1px solid var(--border-color);
        &:hover {
            background-color: rgb(240, 240, 240);
        }
    }
    .logs {
        background-color: white;
        padding: 20px;
        border-radius: 10px;
        border: 1px solid var(--border-color);
    }
    .filters {
        border-radius: 10px;
        border: 1px solid var(--border-color);
    }
    .log-info {
        white-space: pre-line;
    }
</style>